// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  --primaryTheme: var(--primaryThemeColor, #f9f9f9);
  --secondaryTheme: var(--secondaryThemeColor, #c9c9c9);
  --primaryFontTheme: var(--primaryFontThemeColor, #1f1f1f);
  --secondaryFontTheme: var(--secondaryFontThemeColor, #2d2d2d);
}
.App.darkMode {
  --primaryThemeColor: #1f1f1f;
  --secondaryThemeColor: #2d2d2d;
  --primaryFontThemeColor: #f9f9f9;
  --secondaryFontThemeColor: #c9c9c9;
}

body,
.App {
  background-color: var(--secondaryTheme);
  min-height: 100vh;
  font-size: 1rem;
}

a {
  color: #35afaf !important;
  text-decoration: none;
}

#nav-bar-wrapper {
  opacity: 1;
}

.dashChart {
  width: 100%;
}
.dashChart img {
  width: 100%;
}

.flexBox {
  display: flex;
  gap: 1rem;
}

.flexColumn {
  display: flex;
  flex-direction: column;
}

.flexEnd {
  justify-content: flex-end;
}

.flexCenter {
  justify-content: center;
}

.flex-column {
  flex-direction: column;
}

.chartBox {
  box-shadow: 0px 0px 14px #474747;
  background-color: var(--primaryTheme);
  width: 100%;
  max-width: 1200px;
}
.chartBox .chartTitle {
  width: 100%;
}
.chartBox .chartTitle h2 {
  text-align: center;
  font-weight: normal;
}

.chartOptions {
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 4rem;
  border-bottom: 1px solid var(--secondaryFontTheme);
  max-width: calc(1200px - 2rem);
}

.chartDropdown {
  width: 200px;
}

table thead th.MuiTableCell-root {
  font-weight: bold;
  background-color: var(--primaryTheme) !important;
  color: var(--primaryFontTheme);
}

.css-1jy569b-MuiFormLabel-root-MuiInputLabel-root {
  color: #35afaf;
}

.MuiFormControl-root label {
  color: var(--secondaryFontTheme);
}

button.MuiButton-containedPrimary,
label.MuiButton-containedPrimary {
  background-color: #35afaf;
}
button.MuiButton-containedPrimary:hover,
label.MuiButton-containedPrimary:hover {
  background-color: #309e9e;
}

button.MuiButton-containedSecondary,
label.MuiButton-containedSecondary {
  background-color: #f9543a;
}
button.MuiButton-containedSecondary:hover,
label.MuiButton-containedSecondary:hover {
  background-color: #f83a1c;
}

button.MuiButton-containedPrimary.Mui-disabled,
label.MuiButton-containedPrimary.Mui-disabled {
  background-color: #1b5858;
}
button.MuiButton-containedPrimary.Mui-disabled:hover,
label.MuiButton-containedPrimary.Mui-disabled:hover {
  background-color: #1b5858;
}

button.MuiButton-containedSecondary.Mui-disabled,
label.MuiButton-containedSecondary.Mui-disabled {
  background-color: #951805;
}
button.MuiButton-containedSecondary.Mui-disabled:hover,
label.MuiButton-containedSecondary.Mui-disabled:hover {
  background-color: #951805;
}

/*Made Content flex*/
.app-main-content {
  display: flex;
  overflow: hidden;
  height: 100vh;
}

.app-content {
  flex: 1 1;
  transition: 0.2s;
  color: var(--primaryFontTheme);
  padding: 110px 2rem 1rem 2rem;
  overflow: auto;
  margin: 80px 0 0 0;
  padding: 30px 2rem 1rem 2rem;
}

.mobile-only {
  display: none;
}

#profile-page {
  padding: 1rem;
}
#profile-page p {
  font-size: 20px;
  font-weight: 600;
  color: #35afaf;
}
#profile-page p span {
  font-size: 18px;
  font-weight: 500;
  color: var(--primaryFontTheme);
}

@media only screen and (max-width: 899px) {
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: block;
  }
}
iframe {
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/App.scss","webpack://./src/tokens.scss"],"names":[],"mappings":"AAEA;EACE,iDAAA;EACA,qDAAA;EAEA,yDAAA;EACA,6DAAA;AAFF;AAIE;EACE,4BAAA;EACA,8BAAA;EAEA,gCAAA;EACA,kCAAA;AAHJ;;AAOA;;EAEE,uCAAA;EACA,iBAAA;EACA,eAAA;AAJF;;AAOA;EACE,yBAAA;EACA,qBAAA;AAJF;;AAOA;EACE,UAAA;AAJF;;AAOA;EACE,WAAA;AAJF;AAME;EACE,WAAA;AAJJ;;AAQA;EACE,aAAA;EACA,SAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;AALF;;AAQA;EACE,yBAAA;AALF;;AAQA;EACE,uBAAA;AALF;;AAQA;EACE,sBAAA;AALF;;AAQA;EACE,gCAAA;EACA,qCAAA;EAEA,WAAA;EACA,iBAAA;AANF;AAQE;EACE,WAAA;AANJ;AAQI;EACE,kBAAA;EACA,mBAAA;AANN;;AAWA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kDAAA;EACA,8BAAA;AARF;;AAgBA;EACE,YAAA;AAbF;;AAgBA;EACE,iBAAA;EACA,gDAAA;EACA,8BAAA;AAbF;;AAgBA;EACE,cC1Ga;AD6Ff;;AAeA;EACE,gCAAA;AAZF;;AA2BA;;EAEE,yBC9Ha;ADsGf;AA0BE;;EACE,yBChIgB;ADyGpB;;AA2BA;;EAEE,yBCpIe;AD4GjB;AA0BE;;EACE,yBCtIkB;AD+GtB;;AA2BA;;EAEE,yBC9IqB;ADsHvB;AA0BE;;EACE,yBCjJmB;AD0HvB;;AA2BA;;EAEE,yBCpJuB;AD4HzB;AA0BE;;EACE,yBCvJqB;ADgIzB;;AA2BA,oBAAA;AACA;EACE,aAAA;EACA,gBAAA;EACA,aAAA;AAxBF;;AA0BA;EACE,SAAA;EACA,gBAAA;EACA,8BAAA;EACA,6BAAA;EACA,cAAA;EACA,kBAAA;EACA,4BAAA;AAvBF;;AA0BA;EACE,aAAA;AAvBF;;AA0BA;EACE,aAAA;AAvBF;AAwBE;EACE,eAAA;EACA,gBAAA;EACA,cCzLW;ADmKf;AAwBI;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;AAtBN;;AA2BA;EACE;IACE,aAAA;EAxBF;EA0BA;IACE,cAAA;EAxBF;AACF;AA2BA;EACE,YAAA;AAzBF","sourcesContent":["@import \"./tokens.scss\";\n\n.App {\n  --primaryTheme: var(--primaryThemeColor, #{$primaryLight});\n  --secondaryTheme: var(--secondaryThemeColor, #{$secondaryLight});\n\n  --primaryFontTheme: var(--primaryFontThemeColor, #{$primaryDark});\n  --secondaryFontTheme: var(--secondaryFontThemeColor, #{$secondaryDark});\n\n  &.darkMode {\n    --primaryThemeColor: #{$primaryDark};\n    --secondaryThemeColor: #{$secondaryDark};\n  \n    --primaryFontThemeColor: #{$primaryLight};\n    --secondaryFontThemeColor: #{$secondaryLight};\n  }\n}\n\nbody,\n.App {\n  background-color: var(--secondaryTheme);\n  min-height: 100vh;\n  font-size: 1rem;\n}\n\na {\n  color: $primaryColor !important;\n  text-decoration: none;\n}\n\n#nav-bar-wrapper {\n  opacity: 1;\n}\n\n.dashChart {\n  width: 100%;\n\n  img {\n    width: 100%;\n  }\n}\n\n.flexBox {\n  display: flex;\n  gap: 1rem;\n}\n\n.flexColumn {\n  display: flex;\n  flex-direction: column;\n}\n\n.flexEnd {\n  justify-content: flex-end;\n}\n\n.flexCenter {\n  justify-content: center;\n}\n\n.flex-column {\n  flex-direction: column;\n}\n\n.chartBox {\n  box-shadow: 0px 0px 14px #474747;\n  background-color: var(--primaryTheme);\n  // margin-bottom: 2rem;\n  width: 100%;\n  max-width: 1200px;\n  \n  .chartTitle {\n    width: 100%;\n\n    h2 {\n      text-align: center;\n      font-weight: normal;\n    }\n  }\n}\n\n.chartOptions {\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 4rem;\n  border-bottom: 1px solid var(--secondaryFontTheme);\n  max-width: calc(1200px - 2rem);\n  \n\n  // button {\n  //   width: 150px;\n  // }\n}\n\n.chartDropdown {\n  width: 200px;\n}\n\ntable thead th.MuiTableCell-root {\n  font-weight: bold;\n  background-color: var(--primaryTheme) !important;\n  color: var(--primaryFontTheme);;\n}\n\n.css-1jy569b-MuiFormLabel-root-MuiInputLabel-root {\n  color: $primaryColor;\n}\n.MuiFormControl-root label {\n  color: var(--secondaryFontTheme);\n}\n\n// .chartOptions>.MuiFormControl-root{\n\n//   right: 4rem;\n//   //position: relative !important;\n// }\n\n// @media (max-width: 900px) {\n//   .chartOptions>.MuiFormControl-root{\n//     //position: relative !important;\n//   }\n// }\n\nbutton.MuiButton-containedPrimary,\nlabel.MuiButton-containedPrimary {\n  background-color: $primaryColor;\n\n  &:hover {\n    background-color: $primaryColorHover;\n  }\n}\n\nbutton.MuiButton-containedSecondary,\nlabel.MuiButton-containedSecondary {\n  background-color: $secondaryColor;\n\n  &:hover {\n    background-color: $secondaryColorHover;\n  }\n}\n\nbutton.MuiButton-containedPrimary.Mui-disabled,\nlabel.MuiButton-containedPrimary.Mui-disabled {\n  background-color: $primaryColorDisabled;\n\n  &:hover {\n    background-color: $primaryColorDisabled;\n  }\n}\n\nbutton.MuiButton-containedSecondary.Mui-disabled,\nlabel.MuiButton-containedSecondary.Mui-disabled {\n  background-color: $secondaryColorDisabled;\n\n  &:hover {\n    background-color: $secondaryColorDisabled;\n  }\n}\n\n/*Made Content flex*/\n.app-main-content {\n  display: flex;\n  overflow: hidden;\n  height: 100vh;\n}\n.app-content {\n  flex: 1;\n  transition: 0.2s;\n  color: var(--primaryFontTheme);\n  padding: 110px 2rem 1rem 2rem;\n  overflow: auto;\n  margin: 80px 0 0 0;\n  padding: 30px 2rem 1rem 2rem;\n}\n\n.mobile-only {\n  display: none;\n}\n\n#profile-page {\n  padding: 1rem;\n  p {\n    font-size: 20px;\n    font-weight: 600;\n    color: $primaryColor;\n\n    span {\n      font-size: 18px;\n      font-weight: 500;\n      color: var(--primaryFontTheme);\n    }\n  }\n}\n\n@media only screen and (max-width: 899px) {\n  .desktop-only {\n    display: none;\n  }\n  .mobile-only {\n    display: block;\n  }\n}\n\niframe {\n  border: none;\n}\n","$primaryColor: #35afaf;\n$primaryColorHover: scale-color($primaryColor, $lightness: -10%);\n$primaryColorDisabled: scale-color($primaryColor, $lightness: -50%);\n$secondaryColor: #f9543a;\n$secondaryColorHover: scale-color($secondaryColor, $lightness: -10%);\n$secondaryColorDisabled: scale-color($secondaryColor, $lightness: -50%);\n\n \n $primaryLight: #f9f9f9;\n $secondaryLight: #c9c9c9;\n \n $primaryDark:#1f1f1f;\n $secondaryDark:#2d2d2d;\n\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
